import { createAction } from '@reduxjs/toolkit';

import {
    INTRO_STEP,
    PERPAY_PLUS_SOLO_APPLICATION_STEPS,
} from '@perpay-web/fintech/components/composite/PerpayPlusSoloApplication/PerpayPlusSoloApplicationSteps';
import { useActionObservableCallback } from '@perpay-web/hooks/useActionObservableCallback';
import { useSteps } from '@perpay-web/hooks/useSteps';
import { hookAction$ } from '@perpay-web/services/singletons';
import { createContextProvider } from '@perpay-web/utils/componentUtils';

export const perpayPlusSoloApplicationSetSteps = createAction(
    'PERPAY_PLUS_SOLO_APPLICATION_STEPS::SET_STEP',
    (step) => ({ payload: step }),
);

const perpayPlusSoloApplicationStepsGoBack = createAction(
    'PERPAY_PLUS_SOLO_APPLICATION_STEPS::GO_BACK',
);

const usePerpayPlusSoloApplication = () => {
    const steps = useSteps(PERPAY_PLUS_SOLO_APPLICATION_STEPS, INTRO_STEP);

    useActionObservableCallback(
        hookAction$,
        perpayPlusSoloApplicationSetSteps().type,
        (step) => steps.setStep(step),
    );

    useActionObservableCallback(
        hookAction$,
        perpayPlusSoloApplicationStepsGoBack().type,
        () => steps.goBack(),
    );

    return {
        ...steps,
    };
};

const providerFactory = (Context) => {
    const Provider = ({ children }) => {
        const hook = usePerpayPlusSoloApplication();

        return <Context.Provider value={hook}>{children}</Context.Provider>;
    };

    return Provider;
};

export const [
    PerpayPlusSoloApplicationProvider,
    usePerpayPlusSoloApplicationContext,
] = createContextProvider(providerFactory);
